import { BulletedList } from "./BulletedList";
import type { ContainerProps } from "./Container";
import { Container } from "./Container";

export interface AccordionProps extends ContainerProps {}

export const AccordionV2 = Object.assign(Container, {
  BulletedList,
});
